import { usePopup } from '@/compositions/popup';
import { schemasService } from '@/modules/common/api';
import { genMenuItemEdit, genMenuItemDelete } from '@/utils/list-generators';

export function useManagementItemMenu() {
  const popup = usePopup();

  return {
    genMenu: managementItem => {
      const { id, typeId } = managementItem;
      return [
        genMenuItemEdit(() => {
          popup.open({
            component: () =>
              import(
                '@/modules/object-types/ui/type-card/general/ManagementItemEdit.vue'
              ),
            props: {
              managementItemId: id,
              parentSchemaId: typeId
            }
          });
        }),
        genMenuItemDelete(() => {
          popup.openConfirm({
            component: () =>
              import('@/components/popup/PopupConfirmAction.vue'),
            props: {
              title: 'Delete management item?',
              onConfirm: () => schemasService.delete(id)
            }
          });
        })
      ];
    }
  };
}
